import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const acknowledgementRoutes: RouteObject[] = [
  {
    path: '/acknowledgements',
    element: lazyElement(() => import('./Main')),
    handle: {
      documentTitle: 'Acknowledgements',
      crumb: () => ({ label: 'Acknowledgements', to: '/acknowledgements' }),
    },
  },
];

export default acknowledgementRoutes;
